import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import CommandGatewayIcon from 'components/navigation/CommandGatewayIcon';

export default function CommandFeatureLink({
  to,
  label,
  collapsed = false,
  isActive = false,
}) {
  const { t } = useTranslation();

  if (collapsed) {
    return (
      <Link
        to={to}
        aria-label={label}
        aria-current={isActive ? 'page' : undefined}
        className="mx-auto block w-11 rounded-[var(--rely-radius-surface)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--rely-surface-panel)]"
      >
        <span
          data-nav-icon="command"
          data-icon-name="gateway-core"
          className={cn(
            'flex h-11 w-11 items-center justify-center rounded-[var(--rely-radius-surface)] border transition-colors',
            isActive
              ? 'border-[var(--rely-color-brand-green)] bg-[var(--rely-surface-selected)] text-[var(--rely-text-strong)]'
              : 'border-[var(--rely-border-subtle)] bg-[var(--rely-surface-elevated)] text-[var(--rely-text-muted)] hover:text-[var(--rely-text-strong)]'
          )}
        >
          <CommandGatewayIcon
            className="h-8 w-8 rounded-[10px]"
            aria-hidden="true"
          />
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      aria-current={isActive ? 'page' : undefined}
      data-slot="command-feature-link"
      className={cn(
        'group relative block min-h-[4.5rem] overflow-hidden rounded-[var(--rely-radius-surface)] border bg-neutral-950 p-3',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--rely-surface-panel)]',
        isActive
          ? 'border-[var(--rely-color-brand-green)]'
          : 'border-[var(--rely-border-subtle)] hover:border-primary-300 dark:hover:border-primary-800'
      )}
    >
      <img
        src="/assets/rely-command-gateway-card.webp"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-right"
      />
      <span className="absolute inset-0 bg-gradient-to-r from-neutral-950 via-neutral-950/90 to-transparent" />
      <span className="relative block min-w-0 pr-16 pt-0.5">
        <span className="block text-sm font-semibold leading-none text-white">
          {label}
        </span>
        <span className="mt-1.5 block text-xs leading-4 text-neutral-300">
          {t('sidebar.commandDescription')}
        </span>
      </span>
    </Link>
  );
}
